import React, {useState} from 'react';
import {Nav, NavItem, NavLink, TabContent, TabPane} from 'reactstrap';
import classnames from 'classnames';
import SidebarWrap from '../SidebarWrap'
import {Form, Image, Input, Space} from "antd";
import moment from "moment"
import {ClockCircleOutlined, EnvironmentOutlined, LinkOutlined} from "@ant-design/icons";
import {ASSET_URL} from "../../../../../config";
import {t} from "@lingui/core/macro"
import dayjs from "dayjs";
import {Trans} from "@lingui/react/macro";
import {applyLang} from "../../../../../i18n";
import logger from "../../../../../services/logger"

const EventSingle = (props) => {

    const SubmitHandler = (data) =>{
       logger.debug({ data }, "data")
    }

    const [activeTab, setActiveTab] = useState('1');

    const toggle = tab => {
      if(activeTab !== tab) setActiveTab(tab);
    }

    const {org,lang}=props.context
    const item=props.item

    let image=item.image
    if(!image.startsWith("http")){
        image=ASSET_URL+item.image
    }

    const datemoment=dayjs(item.dateEvent)

        return (
            <div className="wpo-event-details-area section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col col-lg-8">
                            <div className="wpo-event-item">
                                <div className="wpo-event-img">
                                    <Image src={image} width={"100%"}/>

                                    <div className="thumb-text">
                                        <span>{datemoment.date()}</span>
                                        <span>{datemoment.format("MMM").toUpperCase().replace(".","")}</span>
                                    </div>
                                </div>
                                <div className="wpo-event-details-text">
                                    <h2>{item.name}</h2>

                                    <div><Space><ClockCircleOutlined /> à {dayjs(item.dateEvent).format("LT")}</Space></div>

                                    {item.adresse && (
                                        <div style={{marginTop:10}}><Space><EnvironmentOutlined /> {item.adresse}</Space></div>
                                    )}

                                    {item.links.length>0 && (
                                        <div style={{marginTop:20}}>
                                        <Space size="large">
                                            {item.links.map(i=>{
                                                const tLink=applyLang(i,lang)
                                                return (
                                                    <a href={tLink.url} target="_blank" style={{cursor:"pointer"}}><LinkOutlined /> {tLink.name}</a>
                                                )
                                            })}
                                        </Space>
                                        </div>
                                    )}
                                </div>
                                <div className="wpo-event-details-wrap" style={{display:"none"}}>
                                    <div className="wpo-event-details-tab">
                                        <Nav tabs>
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({ active: activeTab === '1' })}
                                                    onClick={() => { toggle('1'); }}
                                                >
                                                    <Trans>Détails</Trans>
                                                </NavLink>
                                            </NavItem>

                                            <NavItem>
                                                <NavLink
                                                    className={classnames({ active: activeTab === '2' })}
                                                    onClick={() => { toggle('2'); }}
                                                >
                                                <Trans>Carte</Trans>
                                                </NavLink>
                                            </NavItem>

                                            <NavItem>
                                                <NavLink
                                                    className={classnames({ active: activeTab === '3' })}
                                                        onClick={() => { toggle('3'); }}
                                                    >
                                                    <Trans>Nous Contactez</Trans>
                                                </NavLink>
                                            </NavItem>
                                        </Nav>
                                    </div>
                                    <div className="wpo-event-details-content">
                                        <TabContent activeTab={activeTab}>

                                            <TabPane tabId="1" id="Schedule">
                                                <div dangerouslySetInnerHTML={{__html:item.content}}/>
                                            </TabPane>

                                            <TabPane tabId="2">
                                                <div className="contact-map enent-map">
                                                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d193595.9147703055!2d-74.11976314309273!3d40.69740344223377!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew+York%2C+NY%2C+USA!5e0!3m2!1sen!2sbd!4v1547528325671"></iframe>
                                                </div>
                                            </TabPane>

                                            <TabPane tabId="3">
                                                <div className="event-contact">
                                                    <div className="wpo-donations-details">
                                                        <Form onFinish={SubmitHandler}>

                                                            <div className="row">
                                                                <Form.Item required name={"prenom"} className="col-12 col-md-6">
                                                                    <Input placeholder={t`Prénom`}/>
                                                                </Form.Item>
                                                                <Form.Item required name={"nom"} className="col-12 col-md-6">
                                                                    <Input placeholder={t`Nom`}/>
                                                                </Form.Item>
                                                            </div>

                                                                <Form.Item required name={"email"}>
                                                                    <Input placeholder={t`Email`}/>
                                                                </Form.Item>
                                                                <Form.Item required name={"message"}>
                                                                    <Input.TextArea placeholder={t`Message`} style={{minHeight:100}} />
                                                                </Form.Item>

                                                                <div className="submit-area col-lg-12 col-12 mt-3">
                                                                    <button type="submit" className="theme-btn submit-btn"><Trans>Valider</Trans></button>
                                                                </div>

                                                        </Form>
                                                    </div>
                                                </div>
                                            </TabPane>
                                        </TabContent>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <SidebarWrap/>

                    </div>
                </div>
            </div>

            );
    }

    export default EventSingle;




